import React, { useContext } from 'react';
import CateringDashboardContext from '../CateringDashboardContext';
import CateringDashboardSub from './CateringDashboardSub';
import { CircularProgress, Grid, Typography } from '@mui/material';
//import CateringContext from '../../../CateringContext';

const CateringDashboardContent = () => {
    const { dashboardWidgets, loading, errorMsg } = useContext(
        CateringDashboardContext
    );

    return (
        <>
            {loading && (
                <CircularProgress
                    size={24}
                    style={{ color: 'black', marginLeft: '5px' }}
                />
            )}

            {errorMsg && (
                <Typography variant="body" color={'red'}>
                    {errorMsg}
                </Typography>
            )}

            <Grid container spacing={3}>
                {dashboardWidgets.map((item, i) => (
                    <Grid item key={i} xs={12} md={6}>
                        <CateringDashboardSub
                            title={item.label}
                            value={item.value}
                            timeline={item.timeline}
                            field={item.additionalField}
                            fieldName={item.additionalKey}
                        />
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

export default CateringDashboardContent;
